module.exports = __webpack_public_path__ + "static/media/b3.8f01d168.gif";